import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminInvoiceSettingsUpdateRequest {
  @jsonMember(Boolean)
  public readonly sendToKsef!: boolean;

  @jsonMember(String)
  public readonly seller!: string;

  @jsonMember(String)
  public readonly temporaryInvoiceBankName!: string;

  @jsonMember(String)
  public readonly temporaryInvoiceAccount!: string;

  public constructor(
    private readonly data: {
      sendToKsef: boolean;
      seller: string;
      temporaryInvoiceBankName: string;
      temporaryInvoiceAccount: string;
    },
  ) {
    this.sendToKsef = this.data.sendToKsef;
    this.seller = this.data.seller;
    this.temporaryInvoiceBankName = this.data.temporaryInvoiceBankName;
    this.temporaryInvoiceAccount = this.data.temporaryInvoiceAccount;
  }
}
